import { Component, OnInit, OnDestroy, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common'; // Importe o token DOCUMENT

@Component({
    selector: 'app-dashboard-site-grupo-ps-page',
    templateUrl: './dashboard-site-grupo-ps-page.component.html',
    styleUrls: ['./dashboard-site-grupo-ps-page.component.css']
})
export class DashboardSiteGrupoPSPageComponent implements OnInit, OnDestroy {

    public site: any;
    public realTimeCards: any[];
    public charts: any[];
    public pageTitle: string = '';
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        public authenticationService: AuthenticationService,
        private sitesService: SitesService,
        private dataService: DataService,
        private spinner: NgxSpinnerService
        //private titleService: Title, // <-- Injetar o Title Service
        //@Inject(DOCUMENT) private document: Document,
        //private renderer: Renderer2
    ) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.spinner.show();
            const cTipoEquip = params['id'].substring(0, 2);
            const id = params['id'].substring(2, 6)

            this.sitesService.get(id).subscribe(response => {
                this.site = response;

                const grupoPS = this.site.siteGenericos[0];

                if (cTipoEquip == "PS") {
                    this.pageTitle = 'Usina Solar';
                } else if (cTipoEquip == "CH") {
                    this.pageTitle = 'Chiller';
                } else if (cTipoEquip == "GR") {
                    this.pageTitle = 'Gerador';
                } else if (cTipoEquip == "AC") {
                    this.pageTitle = 'Ar Condicionado';
                } else if (cTipoEquip == "BC") {
                    this.pageTitle = 'Bomba de Calor';
                } else if (cTipoEquip == "BD") {
                    this.pageTitle = 'BioGas';
                } else if (cTipoEquip == "BM") {
                    this.pageTitle = 'BioMassa';
                } else if (cTipoEquip == "TB") {
                    this.pageTitle = 'Turbina';
                } else if (cTipoEquip == "CA") {
                    this.pageTitle = 'Caldeira';
                } else if (cTipoEquip == "CC") {
                    this.pageTitle = 'Concessionaria';
                } else if (cTipoEquip == "SE") {
                    this.pageTitle = 'Subestação';
                } else if (cTipoEquip == "PC") {
                    this.pageTitle = 'Planta CO2';
                } else if (cTipoEquip == "PN") {
                    this.pageTitle = 'Planta N2';
                } else if (cTipoEquip == "PR") {
                    this.pageTitle = 'Processo';
                } else if (cTipoEquip == "MN") {
                    this.pageTitle = 'Manutenção';
                } else if (cTipoEquip == "OP") {
                    this.pageTitle = 'Operação';
                } else if (cTipoEquip == "BA") {
                    this.pageTitle = 'Baterias';
                } else if (cTipoEquip == "TT") {
                    this.pageTitle = 'Totalizador';
                } else if (cTipoEquip == "EM") {
                    this.pageTitle = 'Estação Meteorológica';
                } else if (cTipoEquip == "SM") {
                    this.pageTitle = 'Sistema Elétrico';
                } else if (cTipoEquip == "CO") {
                    this.pageTitle = 'Cogeração';
                } else if (cTipoEquip == "EC") {
                    this.pageTitle = 'Emissões de CO2';
                }


                console.log('Valor de pageTitle definido:', this.pageTitle);
                //this.titleService.setTitle(this.pageTitle);
                //this.renderer.setProperty(this.document, 'title', this.pageTitle);
                const tipos = [
                    "PS", "CH", "GR", "AC", "BC", "BD", "BM", "TB",
                    "CA", "CC", "SE", "PC", "PN", "PR", "MN", "OP", "BA", "TT", "EM", "SM", "CO", "EC"
                ];

                // Inicializa no objeto site com arrays vazios
                tipos.forEach(tipo => {
                    this.site[tipo] = [];
                });

                // Preenche com base no siteGenericos
                this.site.siteGenericos.forEach(item => {
                    if (this.site[item.tipoEquipamento]) {
                        this.site[item.tipoEquipamento].push(item);
                    }
                });

                // Processa cada tipo de forma genérica
                tipos.forEach(tipo => {
                    if (this.site[tipo].length > 0 && cTipoEquip == tipo) {
                        this.site[tipo].forEach(equipamento => {
                            if (equipamento.var_status) {
                                let card = {
                                    tags: [],
                                    getIconClass: () => "",
                                    iconWidth: "25px",
                                    getLabel: () => equipamento.nomeEquipamento,
                                    getValue: () => { }
                                };

                                // Monta as tags dinamicamente
                                card.tags.push(
                                    { tag: equipamento.var_status, UN: '', nome: 'Status' },
                                    { tag: equipamento.variavel1_Id, UN: equipamento.un1, nome: equipamento.nomevar1 },
                                    { tag: equipamento.variavel2_Id, UN: equipamento.un2, nome: equipamento.nomevar2 },
                                    { tag: equipamento.variavel3_Id, UN: equipamento.un3, nome: equipamento.nomevar3 }
                                );

                                // Função de exibição de valores
                                card.getValue = () => {
                                    return card.tags.filter(t => t.nome !== 'Status' && t.tag && t.tag.trim() !== "").map((t) => {
                                        let v = t.value;
                                        if (isNaN(v)) return `${t.nome}: -`;

                                        let formatted = v.toFixed(1).replace(/[.]/, ",");
                                        if (formatted == "-0,0") formatted = "0,0";

                                        return `${t.nome}: ${formatted} ${t.UN || ""}`.trim();

                                    }).join("<br>");
                                };

                                // Função de ícone
                                card.getIconClass = () => {
                                    let v = Number(card.tags[0].value);
                                    const base = `image-${tipo.toLowerCase()}`;

                                    if (isNaN(v)) return base;

                                    switch (v) {
                                        case 0:
                                            return base; // desligado
                                        case 1:
                                            return `${base}-on`; // alarme
                                        case 2:
                                            return `${base}-alarm`; // ligado                                            
                                        default:
                                            return base;
                                    }
                                };

                                this.realTimeCards.push(card);
                            }
                        });
                    }
                });

                // Atualizações em tempo real
                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000)
                    .subscribe(() => this.refreshCardData());

                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000)
                    .subscribe(() => this.refreshChartData());

                this.spinner.hide();
            });
        });
    }

    ngOnDestroy() {
        if (this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if (this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    }

    refreshCardData() {
        let tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({ items: tags }).subscribe(response => {
            for (let i in response.data) {
                Object.assign(tags[i], response.data[i]);
            }
        });
    }

    refreshChartData() {
        this.charts.forEach(chart => {
            this.updateChart(chart);
        });
    }

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    }
}
